import { ValidationService } from 'projects/services/src/app/validation.service';
import { VALIDATION_TYPE } from './../types';
import { Validators } from '@angular/forms';

const STRING = Object.freeze({
	EMPTY_STRING: '',
	THREE_DOT: '...',
	COMMA_SPACE: ', '
});

const regexQuery = `^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$`
const websitePattern = new RegExp(regexQuery)

const LENGTH = Object.freeze({
	MIN_NAME: 3,
	MAX_NAME: 80,
	MIN_EMAIL: 5,
	MAX_EMAIL: 50,
	MIN_PIN_CODE: 6,
	MAX_PIN_CODE: 6,
	MIN_MOBILE_NUMBER: 10,
	MAX_MOBILE_NUMBER: 10,
	MIN_LANDLINE: 11,
	MAX_LANDLINE: 11,
	MIN_ORGANISATION_NAME: 3,
	MAX_ORGANISATION_NAME: 100,
	MIN_DESIGNATION_NAME: 3,
	MAX_DESIGNATION_NAME: 50,
	MIN_COURSE_NAME: 4,
	MAX_COURSE_NAME: 170,
	MIN_COURSE_DESCRIPTION: 3,
	MAX_COURSE_DESCRIPTION: 1000,
	MIN_SECTOR_NAME: 3,
	MAX_SECTOR_NAME: 20,
	MAX_DESCRIPTION: 100,
	MAX_LONG_DESCRIPTION: 1000,
	MAX_COMPANYDESCRIPTION: 400,
	MIN_COMPANYDESCRIPTION: 100,
	MIN_PROJECT_NAME: 3,
	MAX_PROJECT_NAME: 100,
	MIN_PROJECT_PROPOSAL_ID: 3,
	MAX_PROJECT_PROPOSAL_ID: 50,
	MIN_TC_NAME: 3,
	MAX_TC_NAME: 100,
	MIN_COMPANY_NAME: 3,
	MAX_COMPANY_NAME: 30,
	MIN_TRAINING_TARGET: 3,
	MAX_TRANING_TARGET: 3,
	MAX_WEBSITE_LENGTH: 2000,
	MIN_ADDRESS_LANDMARK: 5,
	MAX_ADDRESS_LANDMARK: 100,
	MAX_ADDRESS_DETAIL: 500,
	MIN_WORKING_HOURS: 1,
	MAX_WORKING_HOURS: 2,
});

export const FIELD_LENGTH = LENGTH;

export const Validation = {
	[VALIDATION_TYPE.NAME]: [
		Validators.minLength(LENGTH.MIN_NAME),
		Validators.maxLength(LENGTH.MAX_NAME),
		Validators.pattern(`[a-zA-Z]+[a-zA-Z&\\. ']*$`)
	],
	[VALIDATION_TYPE.AA_NAME]: [
		Validators.minLength(LENGTH.MIN_NAME),
		Validators.maxLength(LENGTH.MAX_NAME),
		Validators.pattern(`[a-zA-Z]+[a-zA-Z&\-\\. ']*$`)
	],
	[VALIDATION_TYPE.FILE]: [
		// ValidationService.fileValidator
	],
	[VALIDATION_TYPE.LANDLINE_NUMBER]: [
		Validators.pattern('^[0][1-9][0-9]*$'),
		Validators.minLength(LENGTH.MIN_LANDLINE),
		Validators.maxLength(LENGTH.MAX_LANDLINE)
	],
	[VALIDATION_TYPE.EMAIL]: [
		Validators.minLength(LENGTH.MIN_EMAIL),
		Validators.maxLength(LENGTH.MAX_EMAIL),
		// ValidationService.emailValidatorMand
		ValidationService.emailV
	],
	[VALIDATION_TYPE.MOBILE_NUMBER]: [
		Validators.compose([
			Validators.pattern('^[1-9][0-9]{9}$'),
			Validators.minLength(LENGTH.MIN_MOBILE_NUMBER),
			Validators.maxLength(LENGTH.MAX_MOBILE_NUMBER)
		])
	],
	[VALIDATION_TYPE.DATE_DURATION]: [
		// ValidationService.dateDurationValidation()
	],
	[VALIDATION_TYPE.POSITIVE_NUMBER]: [ValidationService.number(-1, true)],
	[VALIDATION_TYPE.PIN_CODE]: [
		Validators.compose([
			Validators.pattern('^[1-9][0-9]*$'),
			Validators.minLength(LENGTH.MIN_PIN_CODE),
			Validators.maxLength(LENGTH.MAX_PIN_CODE)
		])
	],
	[VALIDATION_TYPE.ORGANISATION_NAME]: [
		Validators.minLength(LENGTH.MIN_ORGANISATION_NAME),
		Validators.maxLength(LENGTH.MAX_ORGANISATION_NAME),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.LONG_ORGANISATION_NAME]: [
		Validators.minLength(LENGTH.MIN_ORGANISATION_NAME),
		Validators.maxLength(LENGTH.MAX_ADDRESS_DETAIL),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.DESIGNATION]: [
		Validators.minLength(LENGTH.MIN_DESIGNATION_NAME),
		Validators.maxLength(LENGTH.MAX_DESIGNATION_NAME),
		ValidationService.alphaNumeric(),
		Validators.pattern(/^[A-Z]+[\d\w\.\s\-_\/,&\(\)'":]*$/i)
	],
	[VALIDATION_TYPE.COURSE_NAME]: [
		Validators.minLength(LENGTH.MIN_COURSE_NAME),
		Validators.maxLength(LENGTH.MAX_COURSE_NAME),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.SECTOR_NAME]: [
		Validators.minLength(LENGTH.MIN_SECTOR_NAME),
		Validators.maxLength(LENGTH.MAX_SECTOR_NAME),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.DESCRIPTION]: [
		Validators.maxLength(LENGTH.MAX_DESCRIPTION),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.LONG_DESCRIPTION]: [
		Validators.maxLength(LENGTH.MAX_LONG_DESCRIPTION),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.PROJECT_NAME]: [
		Validators.minLength(LENGTH.MIN_PROJECT_NAME),
		Validators.maxLength(LENGTH.MAX_PROJECT_NAME),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*/i)
		// Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.PROJECT_PROPOSAL_ID]: [
		Validators.minLength(LENGTH.MIN_PROJECT_PROPOSAL_ID),
		Validators.maxLength(LENGTH.MAX_PROJECT_PROPOSAL_ID),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*/i)
		// Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.TC_NAME]: [
		Validators.minLength(LENGTH.MIN_TC_NAME),
		Validators.maxLength(LENGTH.MAX_TC_NAME),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\d\w\.\-_\/,&\(\)#:][\d\w\. \-_\/,&\(\)#:]*$/i)
	],
	[VALIDATION_TYPE.URL]: [
		Validators.pattern("((http|https)://)(www.)?"+ "[a-zA-Z0-9@:%._\\+~#?&//=]"
		+ "{2,256}\\.[a-z]"+ "{2,6}\\b([-a-zA-Z0-9@:%"+ "._\\+~#?&//=]*)")
	],
	[VALIDATION_TYPE.TRAINING_TARGET]: [
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.COURSE_DESCRIPTION]: [
		Validators.minLength(LENGTH.MIN_COURSE_DESCRIPTION),
		Validators.maxLength(LENGTH.MAX_COURSE_DESCRIPTION),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.COMPANY_NAME]: [
		Validators.maxLength(LENGTH.MAX_COMPANY_NAME),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.COMPANY_DESCRIPTION]: [
		Validators.minLength(LENGTH.MIN_COMPANYDESCRIPTION),
		Validators.maxLength(LENGTH.MAX_COMPANYDESCRIPTION),
		Validators.pattern(/[\w\d]+[\d\w\./s\-_\/,&\(\):]*$/i)
	],
	[VALIDATION_TYPE.WEBSITE]: [
		// tslint:disable-next-line:max-line-lengths
		Validators.pattern(websitePattern),
		// Validators.pattern(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/),
		Validators.maxLength(LENGTH.MAX_WEBSITE_LENGTH)
	],
	[VALIDATION_TYPE.PERCENTAGE]: [ValidationService.percentageValidator()],
	[VALIDATION_TYPE.AADHAR]: [
		ValidationService.validAadharChecksum(),
		ValidationService.aadharValidate,
	],
	[VALIDATION_TYPE.TC_ID]: [Validators.pattern(/^([A-Z]{2}[0-9]{6})$/)],
	[VALIDATION_TYPE.ALTNUM]: [Validators.pattern(/^(([0][0-9]{10})|([1-9][0-9]{9}))$/)],
	[VALIDATION_TYPE.ADDRESS_LANDMARK]: [
		Validators.maxLength(LENGTH.MAX_ADDRESS_LANDMARK),
		Validators.minLength(LENGTH.MIN_ADDRESS_LANDMARK),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\d\w\.\-_\/,&\(\)#:][\d\w\. \-_\/,&\(\)#:]*$/),
	],
	[VALIDATION_TYPE.ADDRESS_DETAIL]: [
		Validators.maxLength(LENGTH.MAX_ADDRESS_DETAIL),
		ValidationService.alphaNumeric(),
		Validators.pattern(/[\d\w\.\-_\/,&\(\)#:][\d\w\. \-_\/,&\(\)#:]*$/),
	],
	[VALIDATION_TYPE.ALPHANUMERIC]: [
		ValidationService.alphaNumeric()
	],
	[VALIDATION_TYPE.CAP_ALPHANUMBERIC]: [
		ValidationService.alphaNumeric({
			onlyCapital: true
		})
	],
	[VALIDATION_TYPE.TC_AREA]: [
		Validators.pattern(/^((\d{1,5})|(\d{1,5}[.]\d{1,2}))$/)
	],
	[VALIDATION_TYPE.WORKING_HOURS]: [
		Validators.compose([
			Validators.pattern('^[1-9][0-9]*$'),
			Validators.minLength(LENGTH.MIN_WORKING_HOURS),
			Validators.maxLength(LENGTH.MAX_WORKING_HOURS)
		])
	],
	[VALIDATION_TYPE.DECIMAL_NUMBER]: [
		ValidationService.decimalNumberValidation()
	]
};
